<template>
  <div>
    <sdui-loader v-if="$wait.waiting('fetch-topic-history')" class="p-5" />
    <div v-else>
      <SList is-ordered>
        <SListItem
          v-for="item in historyItems"
          :key="`${item.id}-${item.updated_at}`"
          data-cy="history-item"
          :badges="getBadges(item)"
          :description="`${getDisplayName(item)} · ${$dateFormat.date_time(item.updated_at)}`"
        >
          <template #item-title>
            <p v-if="item.message"
               class="mb-0 white-space-pl"
               data-cy="notice-message"
            >{{ item.message }}</p>
            <p v-else class="mb-0 gray-300 small">
              <i>{{ $t('classbook.notices.is_deleted') }} </i>
            </p>
          </template>
        </SListItem>
      </SList>
    </div>
  </div>
</template>

<script>
import { waitFor } from 'src/config/setup/plugins/waitFor/index.js'
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'
import Classbooks from 'src/api/classbooks.js'

export default {
  name: 'ClassbookNoticeHistory',
  components: { SduiLoader },
  props: {
    notice: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    historyItems: [],
  }),

  computed: {},

  methods: {
    fetchHistory: waitFor('fetch-topic-history', async function () {
      const res = await Classbooks.getNoticesHistoryById(this.notice.classbook_id, this.notice.id)
      this.historyItems = res.data
    }),

    getDisplayName(historyItem) {
      return historyItem?.edited_by?.meta?.displayname || historyItem?.user.meta?.displayname
    },

    getBadges(item) {
      return [
        {
          text: item.category.name,
          color: 'gray-300',
        },
        ...item.users.map((user) => ({
          text: user.meta.displayname,
          color: 'gray',
        })),
      ]
    },
  },

  watch: {},
  created() {
    this.fetchHistory()
  },
}
</script>
